module.exports = {
  setStyle(opts) {
    var styles = []
    Object.keys(opts).forEach(function (style) {
      var origin = opts[style]
      styles.push(style + ':' + origin)
    })
    return styles
  }
}


// WEBPACK FOOTER //
// ./static/components/mask/utils.js